"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _iconList = _interopRequireDefault(require("./iconList"));
var __jsx = _react["default"].createElement;
var mainIcon = function mainIcon(props) {
  var _icon$width, _icon$iconDisabled, _icon$icon;
  var icon = _iconList["default"].find(function (method) {
    return method.type === props.type;
  });
  return __jsx(_Box["default"], {
    sx: {
      minWidth: (_icon$width = icon === null || icon === void 0 ? void 0 : icon.width) !== null && _icon$width !== void 0 ? _icon$width : 0,
      maxWidth: props.minified ? 15 : "auto",
      p: props.minified ? 0 : "s3",
      display: icon !== null && icon !== void 0 && icon.icon ? "block" : "none"
    }
  }, props.disabled ? (_icon$iconDisabled = icon === null || icon === void 0 ? void 0 : icon.iconDisabled) !== null && _icon$iconDisabled !== void 0 ? _icon$iconDisabled : "" : (_icon$icon = icon === null || icon === void 0 ? void 0 : icon.icon) !== null && _icon$icon !== void 0 ? _icon$icon : "");
};
var _default = mainIcon;
exports["default"] = _default;